<template>
  <span>
    <v-app-bar
      color="white"
      fixed
      style="border-radius: 0;">
      <v-toolbar-title>
        <v-btn
          to="/#top"
          text
          color="secondary"
          height="40px">
          <img
            src="logo_newmat.svg"
            alt="Plafond et mur tendus NEWMAT Annecy"
            height="30px">
        </v-btn>
      </v-toolbar-title>

      <v-spacer/>

      <v-toolbar-items class="menunav">
        <v-btn
          to="/#services"
          text
          color="secondary"
          @click="track('expertise')">Expertise</v-btn>
        <v-btn
          to="/#realisations"
          text
          color="secondary"
          @click="track('realisations')">Réalisations</v-btn>
        <v-btn
          to="/#technologie"
          text
          color="secondary"
          @click="track('technologie')">Technologie</v-btn>
        <v-btn
          to="/#devis"
          text
          color="secondary"
          @click="track('devis')">Devis</v-btn>
        <v-btn
          to="/#contact"
          text
          color="secondary"
          @click="track('contact')">Contact</v-btn>
      </v-toolbar-items>
    </v-app-bar>
    <v-content
      id="top"
      class="contenuapp">

      <section>
        <v-parallax
          src="fond6_noblur.jpg"
          height="500"
          class="gradienthero">
          <v-overlay
            :absolute="true"
          >
            <v-layout
              column
              align-center
              justify-center
              class="white--text"
            >
              <span style="position: relative;">
                <img
                  src="garantie10ans.svg"
                  class="pastillegarantie">
                <img
                  src="logo_newmat_white.svg"
                  alt="Plafond et mur tendus NEWMAT Annecy"
                  class="logoparalax">
              </span>
              <div class="subheading mb-4 text-center">
                Installation et pose de plafond et mur tendus en Haute Savoie 74, Savoie 73, Pays de Gex 01.</div>
              <v-btn
                class="mt-12"
                color="lighten-2"
                dark
                large
                href="/#services"
              >
                Découvrir
              </v-btn>
            </v-layout>
          </v-overlay>
        </v-parallax>
      </section>

      <core-actualite/>

      <core-services/>

      <core-realisations/>

      <core-technologie/>

      <core-devis/>

      <core-contact/>

      <v-footer color="black">
        <v-layout
          wrap
          align-center
          class="white--text text-center">
          <v-flex xs4>
            <a
              href="https://www.newmat.com"
              target="_blank">
              <img
                class="logofooter"
                src="logo_newmat_white_white_solo.svg"
                alt="NewMat Plafond Tendu">
            </a>
          </v-flex>
          <v-flex xs4>
            <a
              href="https://www.plafonds-tendus.fr"
              target="_blank"
              class="white--text font-weight-bold textfooter">
              www.plafonds-tendus.fr
            </a>
          </v-flex>
          <v-flex xs4>
            <a
              href="https://www.cma-74.fr"
              target="_blank">
              <img
                class="logofooter"
                src="logochambredesmetiers.png"
                alt="Chambre des métiers de Haute-Savoie">
            </a>
          </v-flex>
          <!-- <v-flex class="align-self-start" xs3>
            <v-card-text class="white--text pt-0 footerlinks">
              Entreprise
              <ul>
                <li>
                  <a href="../entreprise.htm">Entreprise</a>
                </li>
                <li>
                  <a href="../equipe.htm">Équipe</a>
                </li>
                <li>
                  <a href="../partenaire.htm">Partenaires</a>
                </li>
                <li>
                  <a href="../localisation.htm">Localisation</a>
                </li>
              </ul>
            </v-card-text>
          </v-flex>
          <v-flex class="align-self-start" xs3>
            <v-card-text class="white--text pt-0 footerlinks">
              Prestations
              <ul>
                <li>
                  <a href="../prestations.htm">Prestations</a>
                </li>
                <li>
                  <a href="../aspect.htm">Aspect</a>
                </li>
                <li>
                  <a href="../technique.htm">Technique</a>
                </li>
                <li>
                  <a href="../Garantie-qualité.htm">Garanties qualité</a>
                </li>
              </ul>
            </v-card-text>
          </v-flex>
          <v-flex class="align-self-start" xs3>
            <v-card-text class="white--text pt-0 footerlinks">
              Services
              <ul>
                <li>
                  <a href="../service.htm">Services</a>
                </li>
                <li>
                  <a href="../electricite-spot-luminnaire.htm">Électricité</a>
                </li>
                <li>
                  <a href="../menuiserie-bois-pvc.htm">Menuiserie</a>
                </li>
                <li>
                  <a href="../acces-au-plenum.htm">Accés à l’ancien plafond</a>
                </li>
                <li>
                  <a href="../isolation-thermique-phonique.htm">Isolation thermique et phonique</a>
                </li>
              </ul>
            </v-card-text>
          </v-flex>
          <v-flex class="align-self-start" xs3>
            <v-card-text class="white--text pt-0 footerlinks">
              Infos
              <ul>
                <li>
                  <a href="../Processus fabrication.htm">Processus de fabrication</a>
                </li>
                <li>
                  <a href="../nettoyage.htm">Nettoyage</a>
                </li>
                <li>
                  <a href="../lisse-plafond-tendu.htm">Les lisses</a>
                </li>
                <li>
                  <a href="../entretien-des-lisses.htm">Entretien des Lisses</a>
                </li>
              </ul>
            </v-card-text>
          </v-flex> -->
          <v-flex xs12>
            <div class="white--text textfooter">
              &copy;
              1995 - {{ datesite }} |
              Site web réalisé par <a
                class="white--text font-weight-bold"
                href="https://www.thecompagnie.eu"
                target="_blank">TheCompagnie</a> |
              <router-link
                to="/admin"
                class="white--text"
              >
                Accès administration
              </router-link>
            </div>
          </v-flex>
        </v-layout>
      </v-footer>
    </v-content>
    <functions-zoomimg/>
  </span>
</template>

<script>
import {
  mapGetters,
  mapActions
} from 'vuex'
import Vue2Filters from 'vue2-filters'
import moment from 'moment'

export default {
  mixins: [Vue2Filters.mixin],
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters(['actualites', 'realisations']),
    datesite () {
      return moment(new Date()).format('YYYY')
    }
  },
  created () {
    this.$store.dispatch('bindActualites')
    this.$store.dispatch('bindRealisations')
  },
  methods: {
    ...mapActions(['showModal']),
    formatedDate (datetoformat) {
      return moment(datetoformat).format('DD/MM/YYYY')
    },
    activezoom (imgtopass) {
      this.$store.dispatch('fetchSelectedImgzoom', imgtopass)
      this.showModal('Zoomimg')
    },
    track (pagename) {
      this.$gtag.pageview({
        page_path: '/' + pagename
      })
    }
  }
}
</script>

<style lang="scss">

</style>
